// @ts-nocheck
import PropTypes from "prop-types";
import {useTranslation} from "react-i18next";
import {BaseButton} from "@/components";

const WithdrawalSuccess = ({amount, onClose}) => {
  const {t} = useTranslation();
  const isMobile = window.innerWidth <= 768;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: isMobile ? "20px" : "40px",
        textAlign: "center",
        minHeight: "300px",
      }}
    >
      <div
        aria-hidden="true"
        style={{
          fontSize: isMobile ? "64px" : "80px",
          color: "var(--color-success)",
          marginBottom: "var(--space-5-5)",
          lineHeight: 1,
        }}
      >
        ✓
      </div>

      <h2
        style={{
          fontSize: isMobile ? "20px" : "24px",
          fontWeight: 700,
          margin: "0 0 16px 0",
          color: "var(--color-text-primary)",
        }}
      >
        {t("withdrawalSuccessTitle")}
      </h2>

      <p
        style={{
          fontSize: isMobile ? "14px" : "16px",
          color: "var(--color-text-secondary)",
          margin: "0 0 24px 0",
          maxWidth: "400px",
        }}
      >
        {t("withdrawalSuccessMessage")}
      </p>

      <div
        style={{
          background: "var(--color-warning-bg)",
          borderRadius: "var(--radius-xl)",
          padding: isMobile ? "12px 24px" : "16px 48px",
          marginBottom: "var(--space-6-5)",
        }}
      >
        <span
          style={{
            fontFamily: "Poppins",
            fontWeight: 600,
            fontSize: isMobile ? "18px" : "24px",
            color: "var(--color-text-primary)",
          }}
        >
          {new Intl.NumberFormat("es-VE", {
            style: "currency",
            currency: "VES",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(amount)}
        </span>
      </div>

      <BaseButton
        variant="primary"
        size="lg"
        onClick={onClose}
        className="btn-tertiary-hover"
        style={{minWidth: "150px"}}
      >
        {t("withdrawalSuccessClose")}
      </BaseButton>
    </div>
  );
};

WithdrawalSuccess.propTypes = {
  amount: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default WithdrawalSuccess;
